<template>
  <div>
    <b-overlay
      :show="loading"
      rounded="sm"
      spinner-variant="success"
      spinner-type="grow"
    >
      <b-container fluid>
        <b-row class="mb-3">
          <b-col cols="12">
            <PageHeader
              :title="$cte('newCompany.title')"
              :enable-back-link="true"
            />
          </b-col>
        </b-row>
        <b-row class="font-jumper">
          <b-col cols="12">
            <b-card bg-variant="transparent" class="shadow-none">
              <template v-slot:header>
                <b-container fluid>
                  <b-row>
                    <b-col cols="12" class="vertical-center">
                      <h5 class="mb-0">
                        {{ $cte("newCompany.addNewCompany") }}
                      </h5>
                    </b-col>
                  </b-row>
                </b-container>
              </template>

              <b-form @submit.prevent="saveCompany">
                <b-row>
                  <b-col cols="8">
                    <b-form-group
                      id="company-name"
                      :label="$cte('newCompany.name')"
                    >
                      <LanogaSelect
                        v-model="companyData.name"
                        :options="selectOptions"
                        @select="selectCompanyName"
                        :required="true"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group
                      id="company-shortName"
                      :label="$cte('newCompany.shortName')"
                    >
                      <b-form-input
                        v-model="companyData.shortName"
                        type="text"
                        id="company-shortName-input"
                        :placeholder="$cte('newCompany.shortName')"
                        required
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      id="company-taxNumber"
                      :label="$cte('newCompany.taxNumber')"
                      label-for="company-taxNumber-input"
                    >
                      <b-form-input
                        v-model="companyData.taxNumber"
                        type="text"
                        id="company-taxNumber-input"
                        :placeholder="$cte('newCompany.taxNumber')"
                        :disabled="true"
                        required
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      id="company-euVatNumber"
                      :label="$cte('newCompany.euVatNumber')"
                      label-for="company-euVatNumber-input"
                    >
                      <b-form-input
                        v-model="companyData.euVatNumber"
                        type="text"
                        id="company-euVatNumber-input"
                        :placeholder="$cte('newCompany.euVatNumber')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      id="company-hasAccountant"
                      class="mb-0 mt-3"
                      :label="$cte('newCompany.hasAccountant')"
                      label-for="company-hasAccountant-input"
                    >
                      <b-form-checkbox
                        v-model="companyData.hasAccountant"
                        id="company-hasAccountant-input"
                        size="lg"
                        required
                        switch
                      >
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-right">
                    <b-button
                      variant="primary"
                      type="submit"
                      class="mt-3"
                    >
                      {{ $cte("newCompany.save") }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import LanogaSelect from "@/components/LanogaSelect";
import Api from "api-client/index";

export default {
  name: "NewCompany",
  components: {
    LanogaSelect,
    PageHeader,
  },
  data() {
    return {
      loading: false,
      companyData: {
        name: null,
        shortName: null,
        taxNumber: null,
        euVatNumber: null,
        hasAccountant: false,
      },

      selectOptions: {
        apiCallback: Api.getCompaniesAutoComplete,
        formatText: function(val) {
          return val.name;
        },
        formatOption: function(val) {
          return val.name;
        },
        mapperCallback: function(data) {
          return data.result;
        },
        minimumInputLength: 3,
        searchOnServer: true,
        locale: {
          searchPlaceholder: "select.search",
          noResults: "select.noResults",
        },
      },
    };
  },
  methods: {
    setCompanyList() {
      let self = this;
      Api.getMyEnabledCompanies()
        .then((companyResponse) => {
          self.$store.dispatch("app/addCompanyList", companyResponse.data);
          self.loading = false;
          self.$router.push("/app/companies");
        })
        .catch((err) => {
          self.loading = false;
          console.log(" err ", err);
        });
    },

    saveCompany() {
      let self = this;
      self.loading = true;

      let companyData = {
        ...self.companyData,
        name: self.companyData.name.name,
        shortName: self.companyData.shortName,
      };

      Api.saveCompany(companyData)
        .then(() => {
          self.$toast.success({
            title: self.$cte("toast.success"),
            message: self.$cte("upload.toastSuccessShort"),
          });
          self.setCompanyList();
        })
        .catch(() => {
          self.loading = false;
          self.$toast.error({
            title: self.$cte("toast.error"),
            message: self.$cte("upload.toastFailedShort"),
          });
        });
    },

    selectCompanyName(companySelectData) {
      this.companyData.shortName = companySelectData.short_name;
      this.companyData.taxNumber = companySelectData.full_tax_number;
    },
  },
  computed: {},
};
</script>

<style scoped>
.lanoga-select {
  height: 42px !important;
}
</style>
